import { styled, css, Box } from '@mui/material'
import {
  PromotionDetailsInternalProps,
  PromotionDetailsStyles
} from './PromotionDetail.types'
import { getUnitValue } from '../../../utils/processStyles'
import getPaletteColor from '../../../utils/getPaletteColor'
import Image from '../Image'

export const PromotionDetailWrapper = styled(Box, {
  shouldForwardProp: (prop) => !['hasImage'].includes(String(prop))
})<PromotionDetailsStyles & PromotionDetailsInternalProps>(
  ({ radius, color, theme, hasImage, type }) => css`
    border-radius: ${getUnitValue(radius)};
    background-color: ${getPaletteColor(theme, color)};
    display: flex;
    align-items: center;
    justify-content: flex-start;
    width: ${hasImage ? '100%' : 'fit-content'};
    min-height: 18px;
    line-height: 1.2em;
    color: ${getPaletteColor(theme, color, 'contrastText')};
    padding: ${hasImage ? '8px' : '3px'};
    gap: 8px;

    ${type === 'tag' &&
    css`
      background-color: ${color !== 'background.default'
        ? getPaletteColor(theme, color)
        : '#D0F0CF'};
    `}
    ${type === 'detail-extended' &&
    css`
      width: 100%;
      background: ${theme.palette.grey[100]});
    `}
  `
)

PromotionDetailWrapper.defaultProps = {
  radius: 4
}

export const PromotionImage = styled(Image)(() => css``)
PromotionImage.defaultProps = {
  size: 56,
  radius: 4,
  ratio: 90
}
